/**
 * @name                                    main.ts
 * @description                             the main file (entry point)
 * @author                                  Maysara Elshewehy
 * @repo                                    https://github.com/Maysara-Elshewehy/mecs-npm-package
 *
 * @note                                    This script follows the `MECS` code style
*/



/* ┌─────────────────────────────────────── PACK ───────────────────────────────────────┐  */

    export *                                from './modules/electron';

/* └────────────────────────────────────────────────────────────────────────────────────┘  */